<div class="tour-dialog">
    <div class="close">
      <button type="button" mat-icon-button [mat-dialog-close]="'cancel'">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  
    <div class="header-img">
      <img src="/assets/images/OVE_RP_Logo.svg" alt="" />
    </div>
    <mat-dialog-content>
      <h3>{{ dialogData.title}}</h3>
      <span class="mat-body-2">{{ dialogData.description}}</span>
    </mat-dialog-content>
    <mat-dialog-actions class="col">
      <div>
        <button mat-flat-button color="primary" [mat-dialog-close]="'start'">{{ dialogData.start}}</button>
      </div>
      <div class="margin padding s6 top">
        <a class="tour-step-footer mat-caption" (click)="dismissDialog()">{{ dialogData.optOut}}</a>
      </div>
    </mat-dialog-actions>
  </div>
  